import React from 'react'

function FA_program_details() {
  return (
    <div>
      {/* ------------------Mobile view------------------ */}
      <div className="d-sm-block d-md-none">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-6">Unleashing Finance Fundamentals</h1>
                <p className="py-2">
                  Dive into the world of finance with our expert-led courses.
                  Enrol now to unlock financial prowess and pave the way for a
                  brighter future. Your journey begins here.
                </p>
              </div>
              <div className="mt-4 text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  With our extensive curriculum that covers Treasury duties,
                  Corporate Finance, Portfolio Management, Financial Risk
                  Management, and useful tools like Cash and Liquidity
                  Management, you may discover the exciting world of finance.
                  Explore the complexities of the supply chain, the subtleties
                  of working capital, and develop the skill of making decisions
                  based on data. Complete your education with practical
                  experiences by working on minor and major projects. Improve
                  your understanding of money and start a life-changing
                  financial education journey.
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div>
                <div className=" Details_container shadow-lg px-1 py-4">
                  <h1 className="Details_text text-center  pb-2 border-bottom">
                    Finance
                  </h1>
                  <div className="Details_text">
                    <ul className="pt-2">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------Desktop View------------------- */}
      <div className="d-none d-md-block">
        <div className="container">
          <div className="row">
            <div className="col-md-8 detail_1stcomp_img">
              <div className="pt-3 Program_details_1stcomp_text">
                <h1 className="fs-2">Unleashing Finance Fundamentals</h1>
                <p className="py-2">
                  Dive into the world of finance with our expert-led courses.
                  Enrol now to unlock financial prowess and pave the way for a
                  brighter future. Your journey begins here.
                </p>
              </div>
              <div className="mt-3 Program_details_1stcomp_text">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  With our extensive curriculum that covers Treasury duties,
                  Corporate Finance, Portfolio Management, Financial Risk
                  Management, and useful tools like Cash and Liquidity
                  Management, you may discover the exciting world of finance.
                  Explore the complexities of the supply chain, the subtleties
                  of working capital, and develop the skill of making decisions
                  based on data. Complete your education with practical
                  experiences by working on minor and major projects. Improve
                  your understanding of money and start a life-changing
                  financial education journey.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div>
                <div className=" Details_container shadow-lg px-3 py-4">
                  <h1 className="Details_text text-center  pb-4 pt-3 border-bottom">
                    Finance
                  </h1>
                  <div className="Details_text ">
                    <ul className="pt-3">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FA_program_details
